import React, { FC, useEffect, useState, useRef } from "react";
import { Checkbox, Spin } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { find } from "lodash";

import memberService from "@services/members.service";
import "./checkbox.scss";
import { useMemberListStore } from "@stores/useMemberListStore";
import membersService from "@services/members.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { checkBoxObj } from "../constants";
import {
  CASE_STATUS_INFORMATION_UPDATE,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_MODULE_MEMBER_LIST,
  USER_ACTION_TAB_DEFAULT,
  USER_ACTION_TAB_PROFILE_DETAILS,
  USER_ACTION_CARD_USER_REGISTRY,
  USER_ACTION_CARD_MEMBER_LIST_TABLE,
  USER_ACTION_DESCRIPTION_REGISTRY_UPDATE,
} from "@utils/constants";
// import { usePatientProfileStore } from "@stores/patientProfileStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";

type CheckBoxProps = {
  label: string;
  classificationType: string;
  currentMember: any;
  className?: string;
  serviceCallForCaseLoadMasterData?: any;
  style?: any;
  dataIndex: string;
  patientId: any;
  updateStatus?: any;
  getMasterData?: any; // to call te api and update the count in kpi cards on status update;
  disabled?: boolean;
  setPageLoader?: any;
};

const CheckBox: FC<CheckBoxProps> = ({
  label,
  classificationType,
  currentMember,
  className,
  serviceCallForCaseLoadMasterData,
  style,
  dataIndex,
  patientId,
  updateStatus,
  getMasterData,
  disabled,
  setPageLoader,
}: CheckBoxProps) => {
  const [checkFlag, setCheckFlag] = useState(false);
  const [checkBoxLoader, setcheckBoxLoader] = useState(false);
  const memberListData = useMemberListStore((state) => state.data);
  const setMemberListData = useMemberListStore((state) => state.setMemberListData);
  const caseLoadLoader = useMemberListStore((state) => state.caseLoadLoader);
  const setCaseLoadLoader = useMemberListStore((state) => state.setCaseLoadLoader);
  // const [registryDependentProgramsStatus] = usePatientProfileStore((state) => [state.registryDependentProgramsStatus]);
  const memberDetailListRegistryDropDown = useGlobalInformationStore((state) => state.memberDetailListRegistryDropDown);
  const memberDetailClassificationValues = useGlobalInformationStore((state) => state.memberDetailClassificationValues);
  const setMemberDetailClassificationValues = useGlobalInformationStore((state) => state.setMemberDetailClassificationValues);

  const isEditAllowed = useRef<boolean>(true);

  useEffect(() => {
    console.log("CheckBox.useEffect");
    const filteredRegistry = memberDetailListRegistryDropDown?.filter((item: any) => item?.classification === classificationType);
    if (filteredRegistry && filteredRegistry?.length > 0) {
      if (classificationType === "CASELOAD") {
        setCheckFlag(["USER", "SYSTEM"].includes(currentMember?.[filteredRegistry?.[0]?.value]) ? true : false);
      } else {
        // Checking classification store , if store doesn't have value we will check current selected member
        setCheckFlag(["Y"].includes(memberDetailClassificationValues?.[filteredRegistry?.[0]?.classification]) || currentMember?.[filteredRegistry?.[0]?.value] === "Y" ? true : false);
      }
    }
  }, [classificationType, currentMember]);

  useEffect(() => {
    if (dataIndex === "member_caseload_status" && currentMember[checkBoxObj[classificationType]] === "SYSTEM") {
      isEditAllowed.current = false;
    } else {
      const filteredRegistry = memberDetailListRegistryDropDown?.filter((item: any) => item?.optionalValue?.disabled);
      if (filteredRegistry && filteredRegistry?.length > 0 && find(filteredRegistry, { value: dataIndex })) {
        isEditAllowed.current = false;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIndex]);

  const onRegistrySelected = (e: CheckboxChangeEvent) => {
    if (isEditAllowed.current) {
      if (!disabled) {
        setPageLoader(true);
        setcheckBoxLoader(true);
        memberService.classificationUpdate(patientId, e.target.checked, classificationType).subscribe({
          next: (v) => {
            if (updateStatus) {
              updateStatus(
                currentMember,
                CASE_STATUS_INFORMATION_UPDATE,
                USER_ACTION_MODULE_MEMBER_DETAIL,
                USER_ACTION_TAB_PROFILE_DETAILS,
                USER_ACTION_CARD_USER_REGISTRY,
                label,
                USER_ACTION_DESCRIPTION_REGISTRY_UPDATE,
                (caseStatus: string, caseLastActionDate: string) => {
                  updatingCheckboxStatus(e, caseStatus, caseLastActionDate);
                  if (getMasterData) {
                    getMasterData();
                  }
                },
                {
                  key: dataIndex,
                  value: classificationType === "CASELOAD" ? (e.target.checked ? "USER" : "DEFAULT") : e.target.checked ? "Y" : "N",
                }
              );
            } else {
              membersService
                .updateStatus(
                  patientId,
                  CASE_STATUS_INFORMATION_UPDATE,
                  USER_ACTION_MODULE_MEMBER_LIST,
                  USER_ACTION_TAB_DEFAULT,
                  USER_ACTION_CARD_MEMBER_LIST_TABLE,
                  label,
                  USER_ACTION_DESCRIPTION_REGISTRY_UPDATE
                )
                .subscribe({
                  next: (res: any) => {
                    updatingCheckboxStatus(e, res.data.data.caseStatus, res.data.data.caseLastActionDate);
                    if (getMasterData && currentMember.patient_case_status !== res.data.data.caseStatus) {
                      getMasterData();
                    }
                  },
                  error: (error: any) => {
                    console.log(error, "error");
                    updatingCheckboxStatus(e);
                  },
                });
            }
            setcheckBoxLoader(false);
          },
          error: (e: any) => {
            console.log(e);
            setPageLoader(false);
            setcheckBoxLoader(false);
          },
        });
      }
    }
  };

  const updatingCheckboxStatus = (e: any, caseStatus?: string, caseLastActionDate?: string) => {
    const updatedMemberData = memberListData.map((member) => {
      if (member.key === currentMember?.key) {
        if (classificationType === "CASELOAD") {
          member = {
            ...member,
            member_caseload_status: e.target.checked ? "USER" : "DEFAULT",
            ...(caseStatus && { patient_case_status: caseStatus }),
            ...(caseLastActionDate && { case_last_action_date: caseLastActionDate }),
          };
        } else {
          member = {
            ...member,
            [dataIndex]: e.target.checked ? "Y" : "N",
            ...(caseStatus && { patient_case_status: caseStatus }),
            ...(caseLastActionDate && { case_last_action_date: caseLastActionDate }),
          };
        }
      }
      return member;
    });
    membersService.setMemberListFn(updatedMemberData);
    setMemberListData(updatedMemberData);
    if (serviceCallForCaseLoadMasterData && classificationType === "CASELOAD") {
      serviceCallForCaseLoadMasterData(caseLoadLoader, setCaseLoadLoader);
    }
    setcheckBoxLoader(false);
    setMemberDetailClassificationValues({
      ...memberDetailClassificationValues,
      [classificationType]: e.target.checked ? "Y" : "N",
    });
    setCheckFlag(e.target.checked);
  };

  return (
    <Spin spinning={checkBoxLoader} indicator={<HealthemSpinner />}>
      <Checkbox className={`${className} ${disabled ? "light-background" : ""}`} checked={checkFlag} onChange={(e) => onRegistrySelected(e)} style={style}></Checkbox>
    </Spin>
  );
};

export default CheckBox;
